
import { defineComponent } from 'vue';
import { getLanguagesHelper } from '@/heplers';
import { parseHrefHelper } from '@/heplers/stringHelpers';
import LanguageInfo from './LanguageInfo.vue';

export default defineComponent({
  name: 'BlogLink',
  components: {
    LanguageInfo,
  },
  props: {
    link: {
      type: Object,
      default: undefined,
    },
  },
  setup() {
    const parseHref = (url: string) => {
      return parseHrefHelper(url, '/docs/');
    };

    return {
      parseHref,
      getLanguages: getLanguagesHelper,
    };
  },
});
